export const AFFILIATE_PROGRAM_STARTING_POINT = "affiliateProgramStartingPoint";
export const AFFILIATE_PROGRAM_ASSESSMENT = "affiliateProgramAssessment";
export const AFFILIATE_PROGRAM_QUESTIONS = "affiliateProgramQuestions";
export const AFFILIATE_PROGRAM_RESULTS = "affiliateProgramResults";
export const AFFILIATE_PROGRAM_TEAM_MANAGEMENT =
  "affiliateProgramTeamManagement";
